export default {
    getStockOrderList: state => {
        return state.stockOrderList;
      },
    getEmptyStockOrder: state => {
      return state.emptyStockOrder;
    }
}